/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import CustomTable from '../../../components/CustomTable'
import { handleConfirm, handleTableSelect, statusType } from '../../../context/utils'
import { Button, Drawer, Dropdown, Form, Input, Modal, Select, Switch, Tag } from 'antd'
import { FaPlus } from 'react-icons/fa6'
import { PiDotsThreeOutlineBold } from 'react-icons/pi'
import { SlEye } from 'react-icons/sl'
import { BiEdit, BiUser } from 'react-icons/bi'
import { GoTrash } from 'react-icons/go'
import moment from 'moment'
import { useDeleteModel, useGetModel, useGetModels, usePatchModel, usePostModel } from '../../../hooks/model/model'
import { useGetBrands } from '../../../hooks/brands/brands'
import { useGetProducts } from '../../../hooks/products/products'
import SearchPage from '../../../components/searchPage'

function ModelManagementPage() {
  const [selected, setSelected] = useState({})
  const [search, setSearch] = useState('')
  const [isModelOpen, setIsModelOpen] = useState(false)
  const onModelClose = () => setIsModelOpen(false)
  // const onModelOpen = () => setIsModelOpen(true)
  const [isOpen, setIsOpen] = useState(false)  
  const [createModelPayload, setCreateModelPayload] = useState({    
    // isActive:"",
    name: "",
    brandId: "",
    id: "",
    productId: ""
})
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const onClose = () => {
    setIsOpen(false)
    form.resetFields();
}
const onCloseEdit = () => {
  setIsOpenEdit(false)
  form.resetFields();
  setSelected()
}
  const onOpen = () => setIsOpen(true)
  const onOpenEdit = () => setIsOpenEdit(true)
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()

  const {
    data: getModelsData,
    refetch: getModelsFetch,
    isFetching: getModelsLoad,
  } = useGetModels(
    {SearchString: search},
    ["SearchString"],
  )

  const {
    data: getModelData,
    mutate: getModelAction,
    isLoading: getModelLoad,
  } = useGetModel(onOpenEdit)

  const {
    data: getProductsData,
    isFetching: getProductsLoad,
  } = useGetProducts()

  useEffect(() => {
    setCreateModelPayload({
      name: getModelData?.data?.name || "",
      id: getModelData?.data?.id || "",
      brandId: getModelData?.data?.brand?.id || "",
      productId: getModelData?.data?.product?.id || ""
    })
    
  }, [getModelData?.data])

  const {
    data: getBrandsData,
    isFetching: getBrandsLoad,
  } = useGetBrands()

  const successAction = () => {
    getModelsFetch();
    onClose();
    onCloseEdit()
    form.resetFields();
    setSelected()
  };

  const {
    mutate: postModelAction,
    isLoading: postModelLoad,
  } = usePostModel(successAction)

  const {
    mutate: putModelAction,
    isLoading: putModelLoad,
  } = usePatchModel(successAction)

  const {
    mutate: deleteAction,
    isLoading: deleteLoad,
  } = useDeleteModel(successAction)


  const handleEdit = (d) => {
    setSelected(d)
    getModelAction(d.id)
  }
  const columns = useMemo(() => [
    {
      title: "Name",
      dataIndex: "name",
      key:"name"
    },
    {
      title: "Brand",
      dataIndex: "brand",
      key:"Brand",
      render: (d) => <p className='text-xs font-medium text-silver uppercase'>{d.name}</p>
    },
    {
      title: "Category",
      dataIndex: "product",
      key:"Product",
      render: (d) => <p className='text-xs font-medium text-silver uppercase'>{d.name}</p>
    },
    {
      title: "Date",
      dataIndex: "dateCreated",
      key: "dateCreated",
      render: (d) => <p className='text-xs font-medium text-silver lowercase'>{moment(d).format('L')} - {moment(d).format('LT')}</p>
    },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomLeft"
        menu={{items: [
        //   {key: "view", icon: <SlEye className='!text-base' />, label: <button id=''>View</button>},
          {key: "edit", label: <button className='flex' onClick={()=>handleEdit(data)}><BiEdit className='!text-base mx-4 py-auto' /> Edit</button>},
          {key: "delete", label: <button className='flex' onClick={() => handleConfirm({data: data?.id, action: deleteAction})}><GoTrash className='!text-base mx-4 py-auto' /> Delete</button>},
        ]}}
      >
        <Button loading={getModelLoad || deleteLoad} className='!bg-[#F2F6FC]' type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ])

  const onSubmit = (d) => {
    // const isActive = !d.isActive ? true : d.isActive;
    const payload = {
        // isActive,
        name: d.name,
        brandId: d.brandId,
        productId: d.productId
      }
      postModelAction(payload)
  }
  const onSubmitEdit = () => {
    putModelAction(createModelPayload)
    // console.log(createModelPayload)
  }
  const mainLoading = (getModelsLoad || getBrandsLoad || getProductsLoad)
  return (
    <PadContainer loading={mainLoading}>
      <TitleContainer
        path={false}
        className="border border-lit rounded-xl"
        title="Model Management"
        action={
          <div className='flex'>
            <SearchPage setSearch={setSearch} size='' />
            <Button onClick={onOpen} className='!bg-light_blue' type='primary' size='large' icon={<FaPlus />}>Add Model</Button>
          </div>
        }
      >
        <CustomTable
          pagination={10}
          column={columns}
          data={getModelsData?.data?.data || []}
          rowSelection={handleTableSelect(rows, setRows, "id")}
        />
      </TitleContainer>


      {/* create edit drawer */}
      <Drawer
        open={isOpen}
        onClose={onClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>New Model</p>}
      >
        
        <Form
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
          form={form}
        >
          <Form.Item label="Model Name" name="name" rules={[{required: true, message: 'Please input Model Name!',},]}>
            <Input size='large' placeholder='Enter Model name' prefix={<BiUser />} />
          </Form.Item>

          <Form.Item label="Brand" name="brandId" rules={[{required: true, message: 'Please input Brand Name!',},]}>
            <Select size='large' placeholder='Select Brand'>
              {getBrandsData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Category" name="productId" rules={[{required: true, message: 'Please input Category Name!',},]}>
            <Select size='large' placeholder='Select Category'>
              {getProductsData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={postModelLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      
      <Drawer
        open={isOpenEdit}
        onClose={onCloseEdit}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit Model</p>}
      >
        
        <Form
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
          form={form}
        >
          <Form.Item label="Model Name" rules={[{required: true, message: 'Please input Model Name!',},]}>
            <Input 
                size='large' 
                placeholder='Enter Model name' 
                prefix={<BiUser />} 
                value={createModelPayload.name}
                onChange={({target:{value}})=> setCreateModelPayload({...createModelPayload, name: value})}
            />
          </Form.Item>

          <Form.Item label="Brand">
            <Select 
                size='large' 
                placeholder='Select Permission' 
                // mode="multiple"
                value={createModelPayload.brandId}
                onChange={(value)=> setCreateModelPayload({...createModelPayload, brandId: value})}
            >
              {getBrandsData?.data?.data?.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Category">
            <Select 
                size='large' 
                placeholder='Select Category' 
                // mode="multiple"
                value={createModelPayload.productId}
                onChange={(value)=> setCreateModelPayload({...createModelPayload, productId: value})}
            >
              {getProductsData?.data?.data?.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          {/* <Form.Item label="Status" valuePropName="checked">
            <Switch 
                checkedChildren="active" 
                unCheckedChildren="inactive" 
                defaultChecked                
                value={createModelPayload.isActive}
                onChange={(checked)=> setCreateModelPayload({...createModelPayload, isActive: checked})} 
            />
          </Form.Item> */}

          {/* <Form.Item label="Description" rules={[{required: true, message: 'Please input Description!',},]}>
            <Input.TextArea 
                placeholder='Enter Description' 
                size='large'                 
                value={createModelPayload.description}
                onChange={({target:{value}})=> setCreateModelPayload({...createModelPayload, description: value})}
            />
          </Form.Item> */}

          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCloseEdit} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' onClick={onSubmitEdit} loading={putModelLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Update</Button>
          </div>
        </Form>
      </Drawer>


      {/* create edit Model modal */}
      <Modal
        width={350}
        footer={false}
        open={isModelOpen}
        onCancel={onModelClose}
        title={<p className='text-xl font-bold text-light_blue'>New Category</p>}
      >
        <Form layout='vertical'>
          <Form.Item label="Category Name" name="title">
            <Input size='large' placeholder='Enter category name' />
          </Form.Item>
          <Button htmlType='submit' block className='!bg-light_blue' type='primary' size='large'>Save</Button>
        </Form>
      </Modal>
    </PadContainer>
  )
}

export default ModelManagementPage